import Vue from "vue";

const cache = {}; // url => { expirationDate, response }

class API {
  static async get(endpoint, options = {}) {
    endpoint = API._cleanEndpoint(endpoint);

    if (options.cache) {
      if (endpoint in cache) {
        if (Date.now() < cache[endpoint].expirationDate) {
          return Promise.resolve(cache[endpoint].response);
        }
      }
    }

    return Vue.axios.get(`${endpoint}`, options).then(response => {
      if (response.status === 200) {
        const expirationDate = new Date();
        expirationDate.setMinutes(expirationDate.getMinutes() + 10);
        cache[endpoint] = {
          expirationDate,
          response: response.data
        };
      }
      return Promise.resolve(response.data);
    });
  }

  static async post(endpoint, data = {}, options = {}) {
    endpoint = API._cleanEndpoint(endpoint);

    return Vue.axios.post(`${endpoint}`, data, options).then(response => {
      return Promise.resolve(response.data);
    });
  }

  static async patch(endpoint, data = {}, options = {}) {
    endpoint = API._cleanEndpoint(endpoint);

    return Vue.axios.patch(`${endpoint}`, data, options).then(response => {
      return Promise.resolve(response.data);
    });
  }

  static async put(endpoint, data = {}, options = {}) {
    endpoint = API._cleanEndpoint(endpoint);

    return Vue.axios.put(`${endpoint}`, data, options).then(response => {
      return Promise.resolve(response.data);
    });
  }

  static async delete(endpoint, options = {}) {
    endpoint = API._cleanEndpoint(endpoint);
    return Vue.axios.delete(`${endpoint}`, options).then(response => {
      return Promise.resolve(response.data);
    });
  }

  static _cleanEndpoint(endpoint) {
    if (endpoint.startsWith("/")) {
      endpoint = endpoint.substring("/");
    }
    return endpoint;
  }
}

export default API;
